<template>
	<div style="display: flex">
		
		<sf-card width="500px" height="330px" :title="getMessage_('QWCC002130')" style="margin-top: -4px; margin-left: 19px">
			<template v-if="isLoading">
				<bar-chart :height="280" ref="grpBar" :chartData="datacollection2" :options="optionCollection1" />
			</template>
		</sf-card>

	
		<sf-card
			width="1400px"
			height="330px"
			:title="this.searchParams.searchDate + getMessage_('QWCC001451') + ' ' + getMessage_('QWCC001490') + '(' + getMessage_('SWCC000572') + ')'"
			style="margin-top: -4px; margin-left: 19px"
		>
			<template v-if="isLoading">
				<line-chart :height="280" ref="grpLine" :chartData="datacollection1" :options="optionCollection2" />
			</template>
		</sf-card>
	</div>
</template>

<script>
import Chart from '@/qmsUtils/chartModule';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/MdjYGraph/store/helpers';
export default {
	components: {
		BarChart: Chart.BarChart,
		LineChart: Chart.LineChart
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		datacollection1() {
			return {
				labels: this.LineChartLabel_, 
				datasets: this.lineDataSet_
			};
		},
		datacollection2() {
			return {
				labels: this.stackedLabel_,
				datasets: this.stackedDataSet_
			};
		},
		optionCollection1() {
		
			return {
				//BarChart
				responsive: true,
				maintainAspectRatio: false, 
				tooltips: {
					 callbacks: {
						label: function(tooltipItem, data) {
							return tooltipItem.yLabel + '%';
						}
					}
				},
				plugins: {
					datalabels: {
						color: '#000', 
						anchor: 'end',
						formatter: (value, context) =>{
							return value + '%';
						}
					}
				},
				legend: {
					display: false,
					position: 'top' 
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								suggestedMin: 50,
								suggestedMax: 100
							}
						}
					]
				}
			};
		},
		optionCollection2() {
		
			return {
				//Linechart
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					 callbacks: {
						label: function(tooltipItem, data) {
							let dataIndex = tooltipItem.datasetIndex;
							let type = data.datasets[dataIndex].type;
							let label = data.datasets[dataIndex].label;
							if(type == 'line'){
								let barMaxData = data.datasets[dataIndex].barMaxData;
								let yLabel = tooltipItem.yLabel;
								if(yLabel == barMaxData){
									return label + ': '  + '0%';
								}
								return label + ': ' + (tooltipItem.yLabel - barMaxData).toFixed(1) + '%';
							}
							return label + ': ' + tooltipItem.yLabel;
						}
					}
				}, 
				plugins: {
					datalabels: {
						color: '#000', 
						anchor: 'end',
						formatter: (value, context) =>{
							let type = context.dataset.type;
							if(type == 'line'){
								let barMaxData = context.dataset.barMaxData;
								if(value == barMaxData){
									return '0%';
								}
								return (value - barMaxData).toFixed(1) + '%';
							}
							return '';
						}
					}
				},
				legend: {
					display: true,
					position: 'top' 
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								suggestedMin: 50,
								//suggestedMax: this.chartlcYMaxVal_
							}
						}
					],
					xAxes: [
						{
							offset: true, 
							gridLines: {
								display: false 
							}
						}
					]
				}
			};
		}
	},
	methods: {
		...serviceMethods
	}
};
</script>

<style></style>
